import React from 'react';
import { connect } from 'react-redux';
import "./styles.css";

class Component extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            collapse: true
        }
    }

    render() {
        return(
            <React.Fragment>
                <div style={{display: "flex", paddingTop: "12px"}}>
                    <a style={{paddingTop: "10px"}}
                    onClick={()=>{
                        this.setState({collapse: !this.state.collapse})
                    }}>
                        {(()=>{
                            if(this.state.collapse){
                                return(
                                    <img src={process.env.PUBLIC_URL+ "/img/collapse.svg"}/>
                                )
                            }
                            else{
                                return(
                                    <img src={process.env.PUBLIC_URL+ "/img/uncollapse.svg"}/>
                                )
                            }
                        })()}
                    </a>
                    <div className='work'>
                        <a href={this.props.url} style={{textDecoration: "underline", color: "white"}}>
                            {this.props.work}
                        </a>
                        
                        <div className='workTitle'>
                            {this.props.title}
                        </div>
                        <div className='workDate'>
                                {this.props.date}
                        </div>  
                        {
                            (()=>{
                                if(!this.state.collapse){
                                    return(
                                        <ul style={{color: "white", fontSize: "16px", fontWeight: "400", paddingTop: "20px"}}>
                                            {
                                                this.props.detail.map((d)=>{
                                                   return(
                                                    <li>{d}</li>
                                                   )
                                                })
                                            }
                                            
                                        </ul>
                                    )
                                }
                            })()
                        }
                    </div>
                </div>
                
                
            </React.Fragment>
        );
    }
}

const Redux = connect(store => ({

}))(Component);

export const ExpandComponent = Redux;